import React from 'react';

import Swal from 'sweetalert2';

import {
  CalendarHeader as StyledCalendarHeader,
  CalendarGroup,
  CalendarTitle,
  PrimaryButton,
  IconButton,
  ViewToggle,
  ViewToggleButton,
  CalendarPeriodLabel,
} from '../../Css/StyledCalendarBase.js';

import { NavigationIcon } from '../../Css/StyledCalendarMobile.js';

import {
  VIEW_TYPES,
  getCalendarLegendItems
} from '../../../constants/calendarConstants.js';

import leftArrowImage from '../../../image/left-arrow.png';
import rightArrowImage from '../../../image/right-arrow.png';

const escapeHtml = (value) => {
  return String(value || '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
};

const CalendarHeader = ({
  currentView,
  currentMonthLabel,
  weekRangeLabel,
  selectedDayNumber,
  onGoToToday,
  onPrevPeriod,
  onNextPeriod,
  onViewChange,
  onAddAppointment,
  consultoriosProfesional = []
}) => {

  const buildLegendItemsHtml = () => {
    const legendItems = getCalendarLegendItems(consultoriosProfesional);

    return legendItems
      .map((item) => `
        <div style="
          display:flex;
          align-items:flex-start;
          gap:10px;
          padding:8px 0;
          border-bottom:1px solid #EEF2F7;
        ">
          <span style="
            width:16px;
            height:16px;
            min-width:16px;
            border-radius:5px;
            background:${escapeHtml(item.color)};
            display:inline-block;
            margin-top:2px;
            box-shadow:0 1px 3px rgba(15,23,42,0.18);
          "></span>

          <div>
            <div style="font-weight:700; color:#1F2937;">
              ${escapeHtml(item.title)}
            </div>

            <div style="font-size:12px; color:#6B7280; margin-top:2px;">
              ${escapeHtml(item.description)}
            </div>
          </div>
        </div>
      `)
      .join('');
  };

  const handleNotificationLegendClick = async () => {
    Swal.fire({
      icon: 'info',
      title: 'Ayuda del calendario',
      html: `
        <div style="text-align:left; font-size:14px; line-height:1.5;">
          <p style="margin:0 0 10px;">
            Los colores del calendario ayudan a diferenciar el tipo de evento.
            Las sesiones con paciente se muestran siempre con el mismo color. El consultorio o sede se consulta al abrir el turno.
          </p>

          <div style="margin-top:10px;">
            ${buildLegendItemsHtml()}
          </div>

          <p style="margin:14px 0 6px;">
            <strong>Íconos</strong>
          </p>

          <ul style="padding-left:18px; margin:0;">
            <li><strong>🎥</strong> Turno virtual con link cargado. Se muestra en la vista Día.</li>
            <li><strong>↻</strong> Turno recurrente. Se muestra en la vista Día.</li>
            <li><strong>✉!</strong> Problema con la notificación por email.</li>
          </ul>

          <p style="margin:14px 0 0;">
            El selector de estado indica si el turno está pendiente, realizado,
            cancelado o si el paciente no asistió.
          </p>
        </div>
      `,
      confirmButtonText: 'Entendido'
    });
  };

  return (
    <StyledCalendarHeader>
      <CalendarGroup justify="flex-start">
        {currentView !== VIEW_TYPES.MONTH && (
          <CalendarTitle>
            {currentMonthLabel}
          </CalendarTitle>
        )}

        <PrimaryButton type="button" onClick={onGoToToday}>
          HOY
        </PrimaryButton>

        <button
          type="button"
          aria-label="Ayuda de colores"
          title="Ayuda de colores"
          onClick={handleNotificationLegendClick}
          style={{
            width: '30px',
            height: '30px',
            border: 'none',
            borderRadius: '8px',
            background: 'hsl(210, 40%, 96%)',
            color: 'hsl(0, 0%, 35%)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            fontSize: '15px',
            fontWeight: 800,
            marginLeft: '8px'
          }}
        >
          ?
        </button>
      </CalendarGroup>

      <CalendarGroup justify="center">
        <IconButton
          type="button"
          aria-label="Periodo anterior"
          onClick={onPrevPeriod}
        >
          <NavigationIcon src={leftArrowImage} alt="Anterior" />
        </IconButton>

        <CalendarPeriodLabel>
          {currentView === VIEW_TYPES.MONTH
            ? currentMonthLabel
            : currentView === VIEW_TYPES.DAY
            ? `Día ${selectedDayNumber}`
            : weekRangeLabel || currentMonthLabel}
        </CalendarPeriodLabel>

        <IconButton
          type="button"
          aria-label="Periodo siguiente"
          onClick={onNextPeriod}
        >
          <NavigationIcon src={rightArrowImage} alt="Siguiente" />
        </IconButton>
      </CalendarGroup>

      <CalendarGroup justify="flex-end">
        <ViewToggle>
          <ViewToggleButton
            type="button"
            active={currentView === VIEW_TYPES.MONTH}
            onClick={() => onViewChange(VIEW_TYPES.MONTH)}
          >
            MES
          </ViewToggleButton>

          <ViewToggleButton
            type="button"
            active={currentView === VIEW_TYPES.WEEK}
            onClick={() => onViewChange(VIEW_TYPES.WEEK)}
          >
            SEMANA
          </ViewToggleButton>

          <ViewToggleButton
            type="button"
            active={currentView === VIEW_TYPES.DAY}
            onClick={() => onViewChange(VIEW_TYPES.DAY)}
          >
            DÍA
          </ViewToggleButton>
        </ViewToggle>
      </CalendarGroup>
    </StyledCalendarHeader>
  );
};

export default CalendarHeader;